import { render, staticRenderFns } from "./EventRecap.vue?vue&type=template&id=33882a6e&"
import script from "./EventRecap.vue?vue&type=script&lang=js&"
export * from "./EventRecap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports